import { __assign } from "tslib";
import React, { useMemo } from "react";
import { Button, CircularProgress, TextField } from "@material-ui/core";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import { AddUpdateText, FieldLabel, useStyles } from "./styles";
import { SimpleModal } from "../../components/SimpleModal";
var CreateUpdateSubjectModal = function (_a) {
    var theme = _a.theme, onSubmit = _a.onSubmit, data = _a.data, isOpen = _a.isOpen, onClose = _a.onClose, submitLoading = _a.submitLoading;
    var classes = useStyles();
    var initialVal = useMemo(function () { return ({
        subjectCategoryName: (data === null || data === void 0 ? void 0 : data.id) ? data.name : ""
    }); }, [data]);
    var validationSchema = Yup.object().shape({
        subjectCategoryName: Yup.string().required("This field is required.")
    });
    return (React.createElement(Formik, { enableReinitialize: true, validateOnChange: true, initialValues: initialVal, validationSchema: validationSchema, onSubmit: onSubmit }, function (_a) {
        var errors = _a.errors, isValid = _a.isValid, dirty = _a.dirty, resetForm = _a.resetForm;
        var valid = isValid && dirty;
        return (React.createElement(Form, { id: "my-form" },
            React.createElement(SimpleModal, { theme: theme, title: (data === null || data === void 0 ? void 0 : data.id) ? "Rename Subject" : "Add New Subject", open: isOpen, headerClass: classes.noHeaderMargin, onClose: function () {
                    resetForm();
                    onClose();
                }, text: "", modalWidth: 600, extraContent: React.createElement(React.Fragment, null,
                    React.createElement(FieldLabel, null, "Subject Category Name"),
                    React.createElement(Field, { name: "subjectCategoryName" }, function (_a) {
                        var field = _a.field;
                        return (React.createElement(TextField, __assign({}, field, { placeholder: "Enter New Subject", variant: "filled", color: "primary", size: "small", fullWidth: true, error: !!(errors === null || errors === void 0 ? void 0 : errors.subjectCategoryName), helperText: errors === null || errors === void 0 ? void 0 : errors.subjectCategoryName, InputProps: {
                                style: {
                                    color: "#fff",
                                    border: !!(errors === null || errors === void 0 ? void 0 : errors.subjectCategoryName) ? "1px solid #ed5465" : ""
                                },
                                disableUnderline: true
                            } })));
                    })), footer: React.createElement(Button, { variant: "contained", form: "my-form", type: "submit", color: "primary", disabled: submitLoading || !valid },
                    submitLoading && (React.createElement(CircularProgress, { size: "1rem", color: "inherit", thickness: 2, variant: "indeterminate" })),
                    React.createElement(AddUpdateText, { "$isLoading": submitLoading, "$disabled": submitLoading || !valid, theme: theme }, (data === null || data === void 0 ? void 0 : data.id) ? "Save Changes" : "Add New Subject")) })));
    }));
};
export default CreateUpdateSubjectModal;
//# sourceMappingURL=CreateUpdateSubjectModal.js.map